'use strict';

const $ = require('jquery');

module.exports = function() {
  $('body').on('click', '[data-toggle="dropdown"]', (e) => {
    e.preventDefault();
    const $dropdown = $(e.currentTarget).closest('.dropdown');
    $dropdown.toggleClass('dropdown--visible');
    $dropdown.toggleClass('open'); // Add Bootstrap's open class for compatibility
  });

  $('body').on('click', () => {
    $('.dropdown--visible').removeClass('dropdown--visible');
    $('.dropdown.open').removeClass('open'); // Remove Bootstrap's open class
  });

  $('body').on('click', '.dropdown', (e) => {
    e.stopPropagation();
  }); 
};
